import { render, staticRenderFns } from "./TypeClickable.vue?vue&type=template&id=00ed775f&scoped=true"
import script from "./TypeClickable.vue?vue&type=script&lang=js"
export * from "./TypeClickable.vue?vue&type=script&lang=js"
import style0 from "./TypeClickable.vue?vue&type=style&index=0&id=00ed775f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ed775f",
  null
  
)

export default component.exports